import { html } from "lit-element";
import { DrawSVGTextBaseModule } from "../../ModuleBase/svg-text-base-module";

export class DrawBegroeiingModule extends DrawSVGTextBaseModule {
	constructor(canvas) {
		super(canvas, "Begroeiing");

		this.name = "begroeiing";
		this.icon = svg_begroeiing;
		this.svgTextIndex = 1;
	}
}

window.customElements.define("inspx-draw-begroeiing-module", DrawBegroeiingModule);

const svg_begroeiing = (text) => html`
<svg width="90" height="25" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
<g>
 <title>Layer 1</title>
 <rect ry="14.57132" y="-339.73535" x="76.72171" height="29.14263" width="125.00848" id="rect4152" stroke-width="0.88058" stroke="#000000" fill="#008000" transform="matrix(0.7000007933047275,0,0,0.7546778260958028,-52.35730308686843,257.7308769936135) "/>
 <text stroke="#000000" transform="matrix(1.1003943502116522,0,0,1.1985814288048857,15.164752767566855,-6.598555040820132) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="12.8px" id="svg_3" y="19.79362" x="26.06306" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0.06667" fill="#000000">${text}</text>
</g>
</svg>
`;
